import styled from '@emotion/styled';
import { keyframes } from '@emotion/react';

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: ${({ theme }) => theme.spacing[6]};
    min-height: 200px;
`;

export const Title = styled.h2`
    font-family: ${({ theme }) => theme.font.family};
    font-size: ${({ theme }) => theme.font.size.large};
    font-weight: ${({ theme }) => theme.font.weight.medium};
    color: ${({ theme }) => theme.color.black200};
    margin-bottom: ${({ theme }) => theme.spacing[4]};
`;

export const ProgressBar = styled.div`
    width: 100%;
    max-width: 400px;
    height: 20px;
    background-color: ${({ theme }) => theme.color.grey200};
    border-radius: ${({ theme }) => theme.radius.main};
    overflow: hidden;
`;

export const ProgressFill = styled.div<{ progress: number }>`
    height: 100%;
    width: ${({ progress }) => progress}%;
    background-color: ${({ theme }) => theme.color.green200};
    transition: width 0.3s ease-in-out;
`;

export const ProgressText = styled.span`
    font-family: ${({ theme }) => theme.font.family};
    font-size: ${({ theme }) => theme.font.size.normal};
    color: ${({ theme }) => theme.color.black200};
    margin-top: ${({ theme }) => theme.spacing[2]};
`;

const indeterminateAnimation = keyframes`
    0% {
        left: -40%;
    }
    100% {
        left: 100%;
    }
`;

export const IndeterminateFill = styled.div`
    height: 100%;
    width: 40%;
    background-color: ${({ theme }) => theme.color.green200};
    position: relative;
    animation: ${indeterminateAnimation} 1.5s ease-in-out infinite;
`;

export const IndeterminateBar = styled.div`
    width: 100%;
    max-width: 400px;
    height: 20px;
    background-color: ${({ theme }) => theme.color.grey200};
    border-radius: ${({ theme }) => theme.radius.main};
    overflow: hidden;
    position: relative;
`;
